import React, { useState } from "react";

const TestForm = () => {
  const [questions, setQuestions] = useState([]);

  const handleDragStart = (e, topic) => {
    e.dataTransfer.setData("topic", topic);
  };

  const handleDrop = (e) => {
    const topic = e.dataTransfer.getData("topic");
    if (!topic) return;

    const newQuestion = {
      id: questions.length + 1,
      text: `What do you know about ${topic}?`,
    };

    setQuestions([...questions, newQuestion]);
    e.preventDefault();
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  return (
    <div className="page-wrapper">
      <div className="content">

        <div className="page-header">
          <h4>Test</h4>
          <h6>Drag Topics → Auto Generate Questions</h6>
        </div>

        <div className="card">
          <div className="d-flex" style={{ gap: "30px", padding: "20px" }}>

            {/* Draggable Topics */}
            <div>
              <h4>Topics</h4>
              {["React", "Node.js", "Express", "JavaScript","rrrrrrr"].map((item) => (
                <p
                  key={item}
                  draggable
                  onDragStart={(e) => handleDragStart(e, item)}
                  style={{
                    background: "#eee",
                    padding: "8px",
                    cursor: "grab",
                    marginBottom: "6px",
                    borderRadius: "4px",
                  }}
                >
                  {item}
                </p>
              ))}
            </div>

            {/* Drop Area */}
            <div
              onDrop={handleDrop}
              onDragOver={allowDrop}
              style={{
                border: "2px dashed #444",
                width: "450px",
                minHeight: "300px",
                padding: "15px",
                borderRadius: "6px",
              }}
            >
              <h4>Drop Topic Here ⬇</h4>

              {questions.length === 0 && (
                <p style={{ opacity: 0.5 }}>No questions yet…</p>
              )}

              {/* Auto Added Questions */}
              {questions.map((q, index) => (
                <div key={index} style={{ marginBottom: "15px" }}>
                  <label>
                    {index + 1}️⃣ {q.text}
                  </label>
                  <input
                    type="text"
                    placeholder="Answer..."
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "6px",
                      marginTop: "5px",
                    }}
                  />
                </div>
              ))}
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default TestForm;
